import { WindowExposure } from '../domain/types';

export const propertyWindowExposureLabels: Record<WindowExposure, string> = {
  [WindowExposure.INTERNA]: 'Interna',
  [WindowExposure.ESTERNA]: 'Esterna',
  [WindowExposure.DOPPIA]: 'Doppia',
};
